<template lang="pug">
.mg-popup__container
  .mg-popup__title {{ $t(`popup.${popup}.title`) }}
  .mg-popup__text {{ $t(`popup.${popup}.text`) }}
  .mg-popup__item 
    PrizeItem(:prize="current_reward")
  .mg-popup__buttons
    button.button.button-medium-x15(v-if="!isSuperPrize" @click="handleConfirm")
      span {{ $t(`popup.claim`) }}
    button.button.button-medium-x15(@click="closePopup")
      span {{ getCloseButtonText }}

  
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";

import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState } = createNamespacedHelpers(mg_global);

import PrizeItem from "./../../common/PrizeItem.vue";

export default {
  name: "GetPrizePopup",

  components: { PrizeItem },

  props: {
    isSuperPrize: Boolean,
  },

  data() {
    return {
      in_progress: false,
    };
  },

  computed: {
    ...mapState(["popup", "current_reward"]),

    getCloseButtonText() {
      return !!this.isSuperPrize ? this.$t(`popup.claim`) : this.$t(`popup.close`);
    },
  },

  mounted() {
    if (this.isSuperPrize) {
      this.handleConfirm();
    }
  },

  methods: {
    closePopup() {
      this.$emit("closePopup");
    },

    handleConfirm() {
      if (this.in_progress) return false;

      this.in_progress = true;

      this.$store
        .dispatch(`${mg_global}/claimReward`)
        .then(response => {
          this.$store.dispatch(`${mg_global}/getProgress`);
        })
        .catch(error => {
          this.$notify({
            type: "error",
            closeOnClick: "true",
            duration: 5000,
            group: "collection",
            position: "bottom right",
            text: this.$t(`error.${error.message}`),
          });
        })
        .finally(() => {
          this.in_progress = false;
          if (!this.isSuperPrize) this.closePopup();
        });
    },
  },
};
</script>
